import React from 'react';
import { ccySym } from '@/utils/currencyUtils';
import { ZERO_DEC_CCY } from '@/utils/tripPriceUtils';
import '@/styles/sender-fee.css';

/** Montant à la précision de sa devise (« 21,25 € », « 10 000 FCFA »). */
export const money = (n, ccy) => `${Number(n).toLocaleString('fr-FR', ZERO_DEC_CCY.has(ccy)
  ? { maximumFractionDigits: 0 }
  : { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${ccySym(ccy)}`;

/**
 * Frais Colis2Ship de l'expéditeur et son total (C8) — `fee` : réponse de `GET /missions/sender-fee-preview`, lue par
 * `usePropositionDraft().senderFee(mode)`, ou mission (frais figés, `currency`). L'écran affiche, il ne calcule rien. Offerts (lancement ou 1re mission) :
 * le montant barré et « offerts ». Jamais montré au transporteur.
 */
export default function SenderFeeSummary({ fee, totalLabel = 'Total à payer', withTotal = false }) {
  // Aucun frais (petit trajet : plafond de 15 % ou moins de 0,50 €) : la ligne des frais est masquée (C8). Sans
  // `withTotal`, rien n'est affiché (le prix est le total) ; avec, le total reste — les panneaux d'une proposition
  // n'ont plus d'autre total (décision du 2026-10-29)
  const hasFee = !!fee && fee.sender_fee_listed > 0;
  if (!fee || (!hasFee && !(withTotal && fee.total_charged != null))) return null;
  const ccy = fee.currency;
  const offert = fee.sender_fee_waiver && hasFee;
  return (
    <div className="sfs" data-testid="sender-fee">
      {hasFee && <div className="sfs-row">
        <span>Frais Colis2Ship</span>
        <span data-testid="sender-fee-amount">
          {offert
            ? <><s>{money(fee.sender_fee_listed, ccy)}</s> <strong className="sfs-offert">offerts{fee.sender_fee_waiver === 'FIRST_MISSION' ? ' · 1re mission' : ''}</strong></>
            : money(fee.sender_fee, ccy)}
        </span>
      </div>}
      <div className="sfs-row sfs-total">
        <span>{totalLabel}</span>
        <span data-testid="sender-fee-total">{money(fee.total_charged, ccy)}</span>
      </div>
    </div>
  );
}
